module.exports = __webpack_public_path__ + "static/media/ico-check.d282e32f.svg";